import { render, staticRenderFns } from "./AdminManageColumnTable.vue?vue&type=template&id=5d31e8fe&scoped=true&"
import script from "./AdminManageColumnTable.vue?vue&type=script&lang=js&"
export * from "./AdminManageColumnTable.vue?vue&type=script&lang=js&"
import style0 from "./AdminManageColumnTable.vue?vue&type=style&index=0&id=5d31e8fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d31e8fe",
  null
  
)

export default component.exports